import { useRef, useState } from 'react';
import { logError } from '@/utils/error-logger';

interface UseMfaResendProps<TResult> {
  resendRequest: () => Promise<TResult>;
  onResendSuccess?: (result: TResult) => void;
  onResendError?: () => void;
}

export const useMfaResend = <TResult>({
  resendRequest,
  onResendSuccess,
  onResendError,
}: UseMfaResendProps<TResult>) => {
  const [isResending, setIsResending] = useState(false);
  const isInFlightRef = useRef(false);

  const resend = async () => {
    if (isInFlightRef.current) {
      return;
    }

    isInFlightRef.current = true;
    setIsResending(true);

    try {
      const result = await resendRequest();

      onResendSuccess?.(result);
    } catch (error) {
      logError(error, 'mfa:resend');
      onResendError?.();
    } finally {
      isInFlightRef.current = false;
      setIsResending(false);
    }
  };

  return { isResending, resend };
};
